(function () {
  if (window.__completeTheLookInitialised) return;
  window.__completeTheLookInitialised = true;

  function pushAnalytics(button) {
    if (!window.dataLayer) return;

    var anchorId = button.dataset.ctlAnchorId;

    window.dataLayer.push({
      event: "complete_the_look_add",
      ctl_source: button.dataset.ctlSource,
      ctl_product_id: Number(button.dataset.ctlProductId),
      ctl_anchor_id: anchorId === "cart" ? "cart" : Number(anchorId),
    });
  }

  function refreshCart() {
    document.dispatchEvent(
      new CustomEvent("cart-drawer:refresh", { bubbles: true }),
    );
  }

  function showFeedback(button, text) {
    var label = button.querySelector("span");
    if (!label) return;

    var original = label.textContent;
    label.textContent = text;
    setTimeout(function () {
      label.textContent = original;
    }, 2000);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-ctl-add]");
    if (!button || button.classList.contains("loading")) return;

    event.preventDefault();

    var variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    button.classList.add("loading");
    button.setAttribute("aria-disabled", "true");

    var addUrl =
      ((window.routes && window.routes.cart_add_url) || "/cart/add") + ".js";

    fetch(addUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || "Add failed");
          }
          return data;
        });
      })
      .then(function () {
        pushAnalytics(button);
        refreshCart();
        showFeedback(button, button.dataset.ctlAddedText || "Added");
      })
      .catch(function (error) {
        console.error("Complete the look:", error);
        showFeedback(button, button.dataset.ctlErrorText || "Unavailable");
      })
      .finally(function () {
        button.classList.remove("loading");
        button.removeAttribute("aria-disabled");
      });
  });
})();
